<template>
  <div id="Gamemaster">
    <div id="messages">
      {{ msg }}
    </div>
    <Players
      :players="room.players"
      :gamePhase="room.gamePhase"
      @removePlayer="removePlayer"
    />
    <!-- <div id="startGame">
      <button @click="startGame">START GAME</button>
    </div> -->
    <div id="UpperContainer">
      <Gamephase
        ref="gamephase"
        :phase="room.gamePhase"
        @playerSpecificData="addToPlayerData"
        @msg="setMessage"
      />
      <TelebarqGM_input :players="room.players || []" @send="sendTelebarq" />
    </div>
    <div id="LowerContainer">
      <div id="dataArray">
        <TelebarqGM_output
          :telebarqs="room.telebarqs"
          @msg="setMessage"
          @addToPlayerData="addToPlayerData"
        />
        <template v-for="d in Object.keys(room.barqs)" :key="room.barqs[d].id">
          <div class="barq">
            <div class="time">{{ timeFilter(room.barqs[d].id) }}</div>
            <div class="time from">{{ room.barqs[d].name }}</div>
            <DrawingGM
              :barqId="d"
              :barqs="room.barqs"
              :lock="true"
              :blankForGM="true"
            />
          </div>
        </template>
      </div>
      <SellingListGM
        :totalRevenue="room.totalRevenue"
        :sellingPrice="room.sellingPrice"
        :sellingList="room.sellingList"
        :gamePhase="room.gamePhase"
        :token="token"
        @setMessage="setMessage"
      />
    </div>

    <div id="version">v7</div>
  </div>
</template>

<script>
// import DrawingGM from "./DrawingGM";
import DrawingGM from "./DrawingGM";
// import BarqAnswers from "./BarqAnswers";
import SellingListGM from "./SellingListGM";
import Players from "./PlayersGM";
import TelebarqGM_input from "./TelebarqGM_input";
import TelebarqGM_output from "./TelebarqGM_output";
import Gamephase from "./Gamephase.vue";

export default {
  name: "GameMaster",
  components: {
    // DrawingGM,
    // BarqAnswers,
    DrawingGM,
    SellingListGM,
    Players,
    TelebarqGM_input,
    TelebarqGM_output,
    Gamephase,
  },
  data() {
    return {
      token: this.$route.query.token,
      msg: "",
      msgTimer: null,
      verkaufspreis: 0,
      whichVerkauf: "",
      room: {
        gamePhase: {},
        players: {},
        barqs: {},
      },
      playerSpecificData: [],
      coolDownTimer: null,
      players: {},
    };
  },

  methods: {
    cobHeight(id) {
      const d = 1024;
      if (this.room.barqs[id]) {
        if (this.room.barqs[id].dimensions) {
          return this.room.barqs[id].dimensions.height;
        }
      }
      return d;
    },
    coolDown() {
      if (this.coolDownTimer) {
        this.setMessage("please wait at least 3 seconds for your next request");
        return true;
      }
      this.coolDownTimer = setTimeout(() => {
        this.coolDownTimer = null;
      }, 3000);
      return false;
    },
    loadBarq(barqId) {
      barqId = barqId.substring(barqId.indexOf("#") + 1);
      let src = require("../assets/Barqs/" + barqId + ".png");
      console.log(src);
      return src;
    },
    sendTelebarq(currentTele, recipients) {
      console.log(recipients);
      for (const P in recipients) {
        let data = {
          id: Date.now(), //time
          rawData: {
            userId: P,
            tele: currentTele,
          },
          name: "GM",
          type: "telebarq",
        };
        this.addToPlayerData(data);
      }
      this.setMessage(currentTele + " was sent");
    },
    addToPlayerData(data) {
      console.log(data);
      this.playerSpecificData.push(data);
      return true;
    },
    checkCookie() {
      let c = this.getCookie();
      if (c) {
        // this.players = c.players
        console.log(JSON.stringify(c));
        return true;
      } else {
        console.log("NO cookie found");
        return false;
      }
    },
    setCookie() {
      //save players
      let obj = {
        players: this.players,
      };
      if (this.$cookie.isCookieAvailable("barq-GM")) {
        console.log("cookie found");
        this.getCookie(); //only for printing cookie, can be removed afterwards
        this.$cookie.removeCookie("barq-GM", {
          path: "/",
          domain: "",
        });
      }
      this.$cookie.setCookie("barq-GM", obj);
    },
    getCookie() {
      let cookie = this.$cookie.getCookie("barq-GM");
      // console.log(cookie)
      // console.log(this.$cookie.keys())
      return cookie;
    },
    startGame() {
      //Gm hast started the game, emit to every player
      this.$refs.gamephase.startGame();
      this.setMessage("You have started the game");
      console.log("STARGAME! GM has started the game " + this.room.id);
    },
    removePlayer(playerId) {
      //send to API for removal
      let data = {
        id: Date.now(), //time
        rawData: playerId,
        name: "GM",
        type: "removePlayer",
      };
      console.log("removeplayer: " + playerId);
      this.playerSpecificData.push(data);
    },
    setMessage(msg) {
      this.msg = msg;
      if (this.msgTimer) {
        clearTimeout(this.msgTimer);
      }
      this.msgTimer = setTimeout(() => {
        this.msg = "";
      }, 3000);
    },
    checkToken() {
      this.$http.post("/checkToken", { token: this.token }).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.setMessage(res.data.msg);
          if (res.data.type == "success") {
            this.room = res.data.room; //Grundstruktur

            this.createInterval();
            console.log("token success");
            // console.log(t('submitName'))

            return true;
          }
        } else {
          this.setMessage(
            "cannot connect to server, please check your connection or reload the page"
          );
          // this.setMessage('error bei der Verbindung zum Server, versuchen sie es erneut, checken sie die Internetverbindung...')
          return false;
        }
      });
    },
    createInterval() {
      setInterval(() => {
        this.$http
          .post("/updateRoom", {
            token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
            // room:this.room,
            player: "GM",
            currentEntry: this.room.currentEntry,
            playerSpecificData: this.playerSpecificData,
          })
          .then((res) => {
            if (res.status === 200 && res.data.type == "success") {
              console.log("success, updateRoom");
              if (res.data.emptyRoom) {
                return true;
              }
              // this.$set(this.room, index, res.data.room)
              this.room = res.data.room;
              this.playerSpecificData = [];
              // this.$forceUpdate()
              console.log("new Data");
              // console.log(this.room.sellingList)
              return true;
            }
            return false;
            // this.serverStatus.curr++
          });
      }, 1000);
    },
    //LOCALSTORAGE
    // checkLocalStorage(){
    //   if (typeof localStorage !== 'undefined') {
    //       try {
    //           localStorage.setItem('feature_test', 'yes');
    //           if (localStorage.getItem('feature_test') === 'yes') {
    //               localStorage.removeItem('feature_test');
    //               // localStorage is enabled
    //               this.localStorageAvailable=true
    //           } else {
    //               // localStorage is disabled
    //               //maybe send message
    //               this.localStorageAvailable=false
    //           }
    //       } catch(e) {
    //           // localStorage is disabled
    //           //maybe send message
    //       }
    //   } else {
    //       // localStorage is not available
    //       //maybe send message
    //   }
    // },
    // saveToLocal(){//save the current data into localstorage
    //   if(!this.localStorageAvailable) return false
    //   let data = Object.assign({}, this.$data)
    //   delete data.socket
    //   // console.log(data)
    //   localStorage.setItem('Barq_GM_data',data)
    //   return true
    // },
    // readFromLocal(){
    //   if(!this.localStorageAvailable) return false
    //   let data = localStorage.getItem('Barq_GM_data')
    //   data.socket=null
    //   this.$data = data
    // },

    //FILTERS
    numberFilter(n) {
      return parseInt(n).toLocaleString("de-DE");
    },
    timeFilter(t) {
      var d = new Date(t);
      var output =
        ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
      return output;
    },
  },
  created() {
    if (this.checkToken()) {
      console.log("token success");
    }
    this.$http
      .post("/updateRoom", {
        token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
        // room:this.room,
        currentEntry: -1,
      })
      .then((res) => {
        if (res.status === 200 && res.data.type == "success") {
          console.log("success, updateRoom");
          if (res.data.emptyRoom) {
            return true;
          }
          // this.$set(this.room, index, res.data.room)
          this.room = res.data.room;
          this.players = res.data.room.players;
          // this.$forceUpdate()
          console.log("new Data");
          // console.log(this.room.sellingList)
          return true;
        }
        return false;
        // this.serverStatus.curr++
      });
  },
  beforeUnmount() {},
};
</script>

<style scoped>
.barq {
  background: white;
  margin-bottom: 50px;
  width: 100%;
  position: relative;
}

/* .PopUPBarq {
  display: flex;
  background: white;
  margin: 20px auto;
  width: 1024px;
  aspect-ratio: 1013/680;
  padding: 2px;
  position: relative;
} */
.currentOpenBarq {
  position: relative;
}

.PopUPBarq {
  display: flex;
  background: white;
  margin: 0 auto;
  height: 100%;
  padding: 2px;
  aspect-ratio: 1013 / 680;
  margin-left: 0px;
}

.from {
  top: 70px !important;
}

.time {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 40px;
  z-index: 3;
  background: white;
}

.replyTele {
  position: absolute;
  bottom: calc(50% - 270px);
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 440px;
  text-align: center;
  color: var(--barq-orange);
  background: white;
}

.replyTele > div {
  margin-bottom: 15px;
}

.replyBorder {
  width: 90%;
  margin: 0 auto;
  border-top: 3px solid var(--barq-orange);
}

#container {
  display: flex;
  justify-content: space-around;
}

#UpperContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
}

#LowerContainer {
  display: flex;
}

.pointer:hover {
  cursor: pointer;
}

/* #gamePhase {
  background: #214a7c;
  color: white;
  padding: 20px;
  width: 350px;
  height: 40px;
  font-size: 1.5em;
  display: flex;
  justify-content: space-between;
  line-height: 1.7em;
}

#gamePhase > button {
  margin: 0;
} */

#dataArray {
  width: 69%;
  margin-top: 30px;
  /* display: flex;
  flex-wrap: wrap;
  flex-direction: column; */
}

.sellingList {
  width: 250px;
}

#sellingPrice {
  margin: 30px 0;
}

.longerInput {
  width: 160px;
}

.sellerInput {
  color: #1860b9;
}

.bildhalter {
  position: relative;
}

.bildhalter > * {
  position: absolute;
}

.dataArrayOutput {
  width: 780px;
  margin: 6px;
  position: relative;
  background: white;
  aspect-ratio: 1013/680;
}

#startGame {
  background: #1860b9;
  margin: 0 auto;
  width: 200px;
  line-height: 4em;
}

#FirstStartupPopUp {
  background: #1860b9;
  width: 50%;
  margin: 0 auto;
}

.sellingList > div {
  margin: 10px;
  font-size: 1.5em;
}

.mainFlex {
  display: flex;
}

#Barq3 {
  padding: 0 10px 0 10px;
  width: 60px;
}

.small-margin {
  margin: 10px;
}

#value {
  background: white;
  color: var(--barq-orange);
  padding: 5px;
}

#sellingPrice {
  margin: 30px 0;
}

#middleButton {
  margin-top: 10px;
  margin-left: calc(50% - 59px);
}

.middleText {
  text-align: center;
}

.BigText {
  font-size: 2em;
}

.leftHeadline {
  width: 50px;
  margin-right: 20px;
}

#main {
  width: 900px;
  margin: 0 auto;
}

#messages {
  font-size: 1.6em;
  padding: 10px;
  position: fixed;
  z-index: 3;
  background: white;
  top: 0px;
}

#mainOutline:before {
  border: 2px solid #fff;
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 20px;
  pointer-events: none;
}

#mainOutline {
  padding: 10px;
  border: 5px solid var(--barq-orange);
  border-radius: 20px;
  position: relative;
  margin-top: 20px;
  background: var(--barq-orange);
}

.Barqulator {
  text-align: center;
  font-size: 2.5em;
  color: white;
  margin-bottom: 10px;
}

.buyer {
  padding: 10px;
  background: white;
  border-radius: 30px;
}

p {
  margin: 1em;
}

#approved {
  position: absolute;
  text-align: center;
  right: 1em;
  top: calc(50% - 50px);
}

#approved > div {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background: white;
  margin: 0 auto;
}

.transactionFullfilled {
  background: limegreen !important;
}

#turnover {
  color: #214a7c;
  padding: 10px 30px 10px 20px;
  background: white;
  margin-left: 50px;
  font-size: 2em;
}

/* #Frabank_title {
  line-height: 55px;
  font-size: 2em;
}

#Frabank_main {
  display: flex;
  justify-content: space-between;
  align-items: center;
} */

.longerInput {
  width: 160px;
}

.locationInput {
  width: 220px;
}

input {
  width: 80px;
  height: 40px;
  font-size: 2em;
  margin-left: 20px;
  border: 0px;
}

.buyerInput {
  color: rgb(253, 103, 33);
}

.sellerInput {
  color: #1860b9;
}

button {
  height: 42px;
  border: 1px solid white;
  background: none;
  color: white;
  margin-left: 50px;
}

button:hover {
  background: white;
  color: var(--barq-orange);
}

.middle {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.codeClass,
.bonus,
.rangeClass {
  margin-top: 10px;
}

.codes,
.location,
.codeClass,
.bonus,
.rangeClass {
  display: flex;
  width: 600px;
  flex-wrap: wrap;
}

.location {
  margin-top: 10px;
}

.location > .leftHeadline {
  margin-right: 4px;
}

.rangeClass span {
  color: rgb(253, 103, 33);
  margin-left: -20px;
  margin-top: 1.4em;
  pointer-events: none;
}

.codeClass span,
.bonus span {
  color: rgb(253, 103, 33);
  margin-left: -20px;
  margin-top: 1.4em;
  position: absolute;
  pointer-events: none;
}

#version {
  position: fixed;
  right: 0px;
  bottom: 0px;
}

#Gamemaster {
  background-color: #f2f2f2;
  width: 1024px;
}
</style>
